import React, { useEffect, createElement } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { X } from 'lucide-react';
interface RegistrationPopupProps {
  isOpen: boolean;
  onClose: () => void;
}
// ============================================================================
// REGISTRO — Formulario DIRECTO de GetResponse (web component), tal cual lo diste.
// Sin envíos propios ni proxy: lo maneja GetResponse y registra sus estadísticas.
// ============================================================================
const GR_FORM_ID = '6a2ed493-7d66-4269-849c-54b142183b53';
export function RegistrationPopup({
  isOpen,
  onClose
}: RegistrationPopupProps) {
  useEffect(() => {
    if (!isOpen) return;
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKeyDown);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKeyDown);
      document.body.style.overflow = '';
    };
  }, [isOpen, onClose]);
  return <AnimatePresence data-id="element-99">
      {isOpen && <motion.div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm overflow-y-auto" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} onMouseDown={e => {
      if (e.target === e.currentTarget) onClose();
    }} data-id="element-100">
          <motion.div role="dialog" aria-modal="true" aria-label="Registro al curso gratuito" className="relative w-full max-w-md my-8 p-4 sm:p-6 bg-black border border-gray-800 rounded-2xl shadow-2xl" initial={{
        opacity: 0,
        scale: 0.95,
        y: 16
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 16
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 26
      }} data-id="element-101">
            <button type="button" onClick={onClose} aria-label="Cerrar" className="absolute top-3 right-3 z-10 w-9 h-9 flex items-center justify-center rounded-full bg-black/60 text-gray-300 hover:text-white hover:bg-black/80 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-orange" data-id="element-102">
              <X className="w-5 h-5" data-id="element-103" />
            </button>

            {/* Formulario DIRECTO de GetResponse (tal cual lo diste). */}
            {createElement('getresponse-form', {
          'form-id': GR_FORM_ID,
          e: '1'
        })}
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}